import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('@/views/Home.vue')
// const PropertyListing = () => import('@/views/properties/PropertyListing')
const PropertyDetails = () => import('@/views/properties/PropertyDetails')
// const PropertyTypeListing = () =>
//   import('@/views/properties/PropertyTypeListing')
const CityPropertiesListing = () =>
  import('@/views/cities/CityPropertiesListing')
const AreaPropertiesListing = () =>
  import('@/views/areas/AreaPropertiesListing')
const AdvancedSearch = () => import('@/views/properties/AdvancedSearch')
const RestaurantDetails = () => import('@/views/restaurants/RestaurantDetails')
const PropertyListingGoTrip = () =>
  import('@/views/properties/PropertyListingGoTrip')
const NewsletterUnsubscribe = () => import('@/views/NewsletterUnsubscribe.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/smestaj-ulcinj-ada-bojana',
    name: 'PropertyListing',
    component: PropertyListingGoTrip,
  },
  {
    path: '/listings/:type',
    name: 'PropertyTypeListing',
    component: PropertyListingGoTrip,
  },
  {
    path: '/properties/:id',
    name: 'PropertyDetails',
    component: PropertyDetails,
  },
  {
    path: '/restaurants/:slug',
    name: 'RestaurantDetails',
    component: RestaurantDetails,
  },
  {
    path: '/city/:slug',
    name: 'CityPropertiesListing',
    component: CityPropertiesListing,
  },
  {
    path: '/area/:slug',
    name: 'AreaPropertiesListing',
    component: AreaPropertiesListing,
  },
  {
    path: '/advanced-search',
    name: 'AdvancedSearch',
    component: AdvancedSearch,
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutGoTrip.vue'),
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import('@/views/BookingGoTrip.vue'),
  },
  {
    path: '/rezervacija',
    name: 'OtasyncBooking',
    component: () => import('@/views/OtasyncBooking.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/ContactGoTrip.vue'),
  },
  // Blog
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/BlogListingGoTrip.vue'),
  },
  {
    path: '/blog/:slug',
    name: 'BlogSingle',
    component: () => import('@/views/BlogSingleGoTrip.vue'),
  },
  // Legal
  {
    path: '/legal',
    name: 'Legal',
    component: () => import('@/views/LegalPagesGoTrip.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'NewsletterUnsubscribe',
    component: NewsletterUnsubscribe,
  },
  // Aktivnosti
  {
    path: '/aktivnosti',
    name: 'ActivitiesListing',
    component: () => import('@/views/ActivitiesListing.vue'),
  },
  {
    path: '/aktivnosti/:slug',
    name: 'ActivityDetails',
    component: () => import('@/views/ActivityDetails.vue'),
  },
  // ⚠️ WILDCARD RUTA MORA BITI NA KRAJU!
  {
    path: '/lost',
    name: 'Lost',
    component: () => import('@/views/Lost'),
  },
  {
    path: '*',
    redirect: '/lost',
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

export default router
